import AppLayout from '../layouts/AppLayout'
import React, { useState, useEffect, useContext, useMemo } from 'react'
import { AppContext } from '../contexts/AppContext'
import { json, Link, useNavigate, useParams } from 'react-router-dom'
import Spinner from 'react-activity/dist/Spinner'
import 'react-activity/dist/Spinner.css'
import { HiArrowNarrowRight } from 'react-icons/hi'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import { FiPlus, FiUpload, FiX, FiDownload } from 'react-icons/fi'
import { MdOutlineRemoveCircle, MdOutlineDelete } from 'react-icons/md'
import { useDropzone } from 'react-dropzone'
import '../styles/match.css'
import classNames from 'classnames'
import Swal from 'sweetalert2'
import { getTeamImage } from '../utils/team'
import DataTable from '../components/DataTable'

const formatTimestamp = (timestamp) => {
  if (!timestamp) return ''
  let str = typeof timestamp === 'string' ? timestamp : String(timestamp)
  if (!str.endsWith('Z') && !str.includes('+') && !str.includes('-', 10))
    str += 'Z'
  const date = new Date(str)
  if (isNaN(date.getTime())) return ''
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  })
}

const formatElapsedTime = (addedat, deletedat) => {
  if (!addedat || !deletedat) return ''

  // Ensure Zulu (Z) suffix if not present
  let addedStr = typeof addedat === 'string' ? addedat : String(addedat)
  let deletedStr = typeof deletedat === 'string' ? deletedat : String(deletedat)
  if (
    !addedStr.endsWith('Z') &&
    !addedStr.includes('+') &&
    !addedStr.includes('-', 10)
  ) {
    addedStr += 'Z'
  }
  if (
    !deletedStr.endsWith('Z') &&
    !deletedStr.includes('+') &&
    !deletedStr.includes('-', 10)
  ) {
    deletedStr += 'Z'
  }

  const addedMs = new Date(addedStr).getTime()
  const deletedMs = new Date(deletedStr).getTime()
  if (isNaN(addedMs) || isNaN(deletedMs)) return ''
  const diffMs = deletedMs - addedMs
  if (diffMs < 0) return ''
  const totalMinutes = Math.floor(diffMs / 60000)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours === 0) return `${minutes} Minutes`
  if (minutes === 0) return `${hours} Hours`
  return `${hours} Hours ${minutes} Minutes`
}

const MatchDetails = () => {
  const { matchId } = useParams()

  const navigate = useNavigate()

  const [match, setMatch] = useState('')
  const [categories, setCategories] = useState([])
  const [type, setType] = useState('Live')
  const [linksInput, setlinksInput] = useState('')
  const [parsedLinks, setParsedLinks] = useState([])
  const [linksLoading, setslinksLoading] = useState(false)
  const [scoreLoading, setscoreLoading] = useState(false)
  const [showLinkForm, setshowLinkForm] = useState(false)
  const [showScoreForm, setshowScoreForm] = useState(false)
  const [linkFormLoading, setlinkFormLoading] = useState(false)
  const [linksError, setlinksError] = useState('')
  const [matchLinks, setmatchLinks] = useState([])
  const [filteredLinks, setFilteredLinks] = useState([])
  const [liveCount, setliveCount] = useState(0)
  const [highlightCount, sethighlightCount] = useState(0)
  const [googleCount, setgoogleCount] = useState(0)
  const [totalSpectators, settotalSpectators] = useState(0)
  const [websitesLinks, setwebsitesLinks] = useState([])
  const [team1players, setTeam1players] = useState([])
  const [team2players, setTeam2players] = useState([])
  const [team1score, setTeam1score] = useState('')
  const [team2score, setTeam2score] = useState('')
  const [team1Selects, setTeam1Selects] = useState({})
  const [team2Selects, setTeam2Selects] = useState({})
  const [team1scorers, setTeam1scorers] = useState([])
  const [team2scorers, setTeam2scorers] = useState([])
  const [websites, setWebsite] = useState([])
  const [specwebsites, setspecWebsite] = useState([])
  const [spectatorCounts, setSpectatorCounts] = useState({})
  const [showSpecButton, setshowSpecButton] = useState(false)
  const [specFormLoading, setspecFormLoading] = useState(false)
  const [showTeam1Scorers, setShowTeam1Scorers] = useState(false)
  const [showTeam2Scorers, setShowTeam2Scorers] = useState(false)
  const [activeSection, setActiveSection] = useState('links')
  const [selectedLinkIds, setSelectedLinkIds] = useState([])
  const [uploadedScreenshots, setUploadedScreenshots] = useState([])
  const [uploading, setUploading] = useState(false)
  const [excelDownloading, setExcelDownloading] = useState(false)
  const STATIC_BASE_URL = process.env.REACT_APP_STATIC_URL || ''

  const {
    getmatch,
    getteamplayers,
    getteamscorers,
    getlinkcategories,
    getmatchlinks,
    downloadmatchlinksexcel,
    getmatchwebsites,
    getspecwebsites,
    updatematchspectators,
    addmatchlinks,
    addmatchscore,
    deletematchlink,
    setmatchlinkstakendown,
    setmatchlinkstakendownbulk,
    deletematchlinks,
    removematchlinks,
    isLoading,
  } = useContext(AppContext)

  const fetchMatch = async () => {
    const response = await getmatch(matchId)
    if (response) {
      if (response[0]) {
        setMatch(response[0])

        // Initialize uploaded screenshots from match attachments (array of objects)
        if (Array.isArray(response[0].attachments)) {
          setUploadedScreenshots(response[0].attachments)
        } else {
          setUploadedScreenshots([])
        }
        const response2 = await getteamplayers(response[0].team1)
        setTeam1players(response2)
        const response3 = await getteamplayers(response[0].team2)
        setTeam2players(response3)

        if (response[0].team1score !== '') {
          const response4 = await getteamscorers(response[0].team1, matchId)
          setTeam1scorers(response4)
        }
        if (response[0].team2score !== '') {
          const response5 = await getteamscorers(response[0].team2, matchId)
          setTeam2scorers(response5)
        }
      } else {
        navigate('/all-matches')
      }
    } else {
      navigate('/all-matches')
    }
  }

  useEffect(() => {
    if (matchId) {
      fetchMatch()
      fetchMatchWebsites()
    }
  }, [])

  useEffect(() => {
    if (matchId) {
      fetchMatchlinks(type)
    }
  }, [type])

  const handleSetType = async (t) => {
    setType(t)
    setlinksInput('')
    setshowLinkForm(false)
    setlinksError(false)
    setSelectedLinkIds([])
    fetchMatchlinks(t)
  }

  const fetchCategories = async () => {
    const response = await getlinkcategories(type, matchId)
    setliveCount(response[0].totallivelinks)
    sethighlightCount(response[0].totalhighlightlinks)
    setCategories(response)
  }

  const fetchMatchlinks = async (type) => {
    setslinksLoading(true)
    const response = await getmatchlinks(type, matchId)
    setmatchLinks(response.matchlinks)
    setliveCount(response.totallive)
    sethighlightCount(response.totalhighlights)
    setgoogleCount(response.totalgoogle)
    setwebsitesLinks(response.totalwebsites)
    settotalSpectators(response.totalspectators)
    setslinksLoading(false)
  }

  const fetchMatchWebsites = async () => {
    const response = await getmatchwebsites(matchId)
    setWebsite(response)
    const response2 = await getspecwebsites(matchId)
    setspecWebsite(response2)
  }

  const handleParseLinks = () => {
    if (linksInput.trim() === '') {
      setlinksError('Please paste at least one link')
      return
    }
    let inputLinks = linksInput.split('\n').filter((link) => link.trim() !== '')
    const seen = new Set()
    inputLinks = inputLinks.filter((link) => {
      const key = link.trim().toLowerCase()
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
    const existingLinks = matchLinks.map((ml) => ml.link.trim().toLowerCase())
    const newLinks = inputLinks.filter(
      (link) => !existingLinks.includes(link.trim().toLowerCase()),
    )
    if (newLinks.length === 0) {
      setlinksError('All links already exist')
      return
    }
    setlinksError('')
    setParsedLinks(
      newLinks.map((link) => ({ link: link.trim(), spectators: 0 })),
    )
  }

  const handleDownloadExcel = async () => {
    if (excelDownloading) return
    try {
      setExcelDownloading(true)
      const filenameHint =
        match && match.team1name && match.team2name
          ? `${match.team1name}-vs-${match.team2name}`
          : matchId
      await downloadmatchlinksexcel(matchId, filenameHint)
    } finally {
      setExcelDownloading(false)
    }
  }

  const handleLinksSubmit = async (e) => {
    e.preventDefault()
    if (!isLoading) {
      try {
        setlinkFormLoading(true)
        if (parsedLinks.length > 0) {
          setlinksError('')
          const addedat = new Date().toISOString().slice(0, 19)
          let response = await addmatchlinks(
            parsedLinks,
            type,
            matchId,
            addedat,
          )
          if (response && response.message === 'success') {
            if (response.skipped > 0) {
              Swal.fire(
                'Duplicates skipped',
                `${response.skipped} link${response.skipped > 1 ? 's were' : ' was'} already added and skipped.`,
                'info',
              )
            }
            setlinksInput('')
            setParsedLinks([])
            setshowLinkForm(false)
            fetchMatchlinks(type)
            fetchMatchWebsites()
          }
        } else {
          setlinksError('No links to submit')
          return
        }
      } catch (error) {
        setlinksError('Error: ' + error)
      } finally {
        setlinkFormLoading(false)
      }
    }
  }

  const getDomain = (link, domain) => {
    if (domain) return domain
    try {
      return new URL(link).hostname
    } catch {
      return ''
    }
  }

  const selectableLinkIds = useMemo(
    () => filteredLinks.map((l) => l.id),
    [filteredLinks],
  )
  const allSelectableSelected =
    selectableLinkIds.length > 0 &&
    selectableLinkIds.every((id) => selectedLinkIds.includes(id))

  const websiteIconMap = useMemo(() => {
    const map = new Map()
    if (websitesLinks) {
      websitesLinks.forEach((website) => {
        if (website.link) {
          website.link.split(',').forEach((domain) => {
            map.set(domain.trim().toLowerCase(), website.icon)
          })
        }
      })
    }
    return map
  }, [websitesLinks])

  const getWebsiteIcon = (link) => {
    try {
      const hostname = new URL(link).hostname
        .toLowerCase()
        .replace(/^www\./, '')
      for (const [domain, icon] of websiteIconMap) {
        if (hostname === domain || hostname.endsWith('.' + domain)) {
          return icon
        }
      }
    } catch {}
    return null
  }

  const linkTableColumns = useMemo(() => {
    const cols = []
    if (type === 'Live' || type === 'Highlight') {
      cols.push({
        Header: () => (
          <input
            type='checkbox'
            checked={allSelectableSelected}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedLinkIds([...selectableLinkIds])
              } else {
                setSelectedLinkIds([])
              }
            }}
            title={allSelectableSelected ? 'Deselect all' : 'Select all'}
          />
        ),
        id: 'select',
        width: 42,
        Cell: ({ row }) => {
          const id = row.original.id
          const checked = selectedLinkIds.includes(id)
          return (
            <input
              type='checkbox'
              checked={checked}
              onChange={() => {
                setSelectedLinkIds((prev) =>
                  prev.includes(id)
                    ? prev.filter((x) => x !== id)
                    : [...prev, id],
                )
              }}
            />
          )
        },
      })
    }
    cols.push({
      Header: 'LINK',
      accessor: 'link',
      Cell: ({ value }) => {
        const icon = getWebsiteIcon(value)
        return (
          <div className='flex items-center gap-2'>
            {icon && (
              <img
                width='16'
                height='16'
                src={`${process.env.REACT_APP_STATIC_URL || ''}${icon}`}
              />
            )}
            <a
              href={value}
              target='_blank'
              rel='noreferrer'
              className='text-blue-600 hover:underline truncate block max-w-[400px]'
            >
              {value}
            </a>
          </div>
        )
      },
    })
    cols.push(
      { Header: 'TYPE', accessor: 'type' },
      {
        Header: 'DOMAIN',
        accessor: (row) => getDomain(row.link, row.domain),
        id: 'domain',
      },
      {
        Header: 'SPECTATORS',
        accessor: 'spectators',
        Cell: ({ value }) => (value != null ? value.toLocaleString() : '–'),
      },
      {
        Header: 'NOTICED TIME',
        accessor: 'addedat',
        Cell: ({ value }) => (value ? formatTimestamp(value) : '–'),
      },
      {
        Header: 'TAKE DOWN TIME',
        accessor: 'deletedat',
        Cell: ({ value }) => (value ? formatTimestamp(value) : '–'),
      },
      {
        Header: 'TOTAL TIME ELAPSED',
        id: 'elapsedtime',
        Cell: ({ row }) => {
          const { addedat, deletedat } = row.original
          const result = formatElapsedTime(addedat, deletedat)
          return result || '–'
        },
      },
    )
    if (type === 'Live' || type === 'Highlight') {
      cols.push({
        Header: '',
        id: 'actions',
        Cell: ({ row }) => (
          <div className='flex items-center gap-1'>
            <button
              type='button'
              className='p-2 rounded hover:bg-neutral-100 text-neutral-500 hover:text-red-500'
              onClick={() =>
                handleDelete(row.original.id, row.original.addedat)
              }
              title='Enter take down time'
            >
              <MdOutlineRemoveCircle size={20} />
            </button>
            <button
              type='button'
              className='p-2 rounded hover:bg-neutral-100 text-neutral-500 hover:text-red-600'
              onClick={() => handleDeleteRow(row.original.id)}
              title='Remove link'
            >
              <MdOutlineDelete size={20} />
            </button>
          </div>
        ),
      })
    }
    return cols
  }, [
    type,
    selectedLinkIds,
    selectableLinkIds,
    allSelectableSelected,
    websiteIconMap,
  ])

  const handleDelete = async (id, addedat) => {
    if (!isLoading) {
      try {
        const result = await Swal.fire({
          title: 'Enter take down time',
          icon: 'info',
          html: `
            <label style="display:block;text-align:left;font-size:14px;font-weight:600;margin-bottom:4px;">Minutes elapsed since link was notified</label>
            <input type="number" min="0" id="swal-elapsed-minutes" class="swal2-input" style="width:100%;margin:0;" value="" placeholder="e.g. 10" />
          `,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm take down',
          preConfirm: () => {
            const minutes = parseInt(
              document.getElementById('swal-elapsed-minutes').value,
              10,
            )
            if (isNaN(minutes) || minutes < 0) {
              Swal.showValidationMessage(
                'Please enter a valid number of minutes (0 or more)',
              )
              return false
            }
            const noticedTime = addedat ? new Date(addedat) : new Date()
            const deletedAt = new Date(noticedTime.getTime() + minutes * 60000)
            return deletedAt.toISOString().slice(0, 19)
          },
        })

        if (result.isConfirmed) {
          const deletedAt = result.value || null
          let response = await deletematchlink(id, deletedAt)
          if (response === 'success') {
            fetchMatchlinks(type)
          }
        }
      } catch (error) {
        Swal.fire('An Error Occurred', error, 'error')
      }
    }
  }

  const handleDeleteRow = async (id) => {
    if (isLoading) return
    const result = await Swal.fire({
      title: 'Remove this link?',
      text: 'This will permanently remove the link.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Remove',
    })
    if (result.isConfirmed) {
      const response = await removematchlinks([id])
      if (response === 'success') {
        fetchMatchlinks(type)
        fetchMatchWebsites()
      }
    }
  }

  const handleBulkTakendown = async () => {
    if (isLoading || selectedLinkIds.length === 0) return
    try {
      const result = await Swal.fire({
        title: 'Set take down time for selected links',
        icon: 'info',
        html: `
          <label style="display:block;text-align:left;font-size:14px;font-weight:600;margin-bottom:4px;">Minutes elapsed since link was notified</label>
          <input type="number" min="0" id="swal-elapsed-minutes" class="swal2-input" style="width:100%;margin:0;" value="" placeholder="e.g. 10" />
        `,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Set take down time',
        preConfirm: () => {
          const minutes = parseInt(
            document.getElementById('swal-elapsed-minutes').value,
            10,
          )
          if (isNaN(minutes) || minutes < 0) {
            Swal.showValidationMessage(
              'Please enter a valid number of minutes (0 or more)',
            )
            return false
          }
          return minutes
        },
      })
      if (result.isConfirmed) {
        const minutes = result.value
        const items = matchLinks
          .filter((l) => selectedLinkIds.includes(l.id))
          .map((link) => {
            const noticedTime = link.addedat
              ? new Date(link.addedat)
              : new Date()
            const deletedAt = new Date(noticedTime.getTime() + minutes * 60000)
              .toISOString()
              .slice(0, 19)
            return { id: link.id, deletedat: deletedAt }
          })
        const response = await setmatchlinkstakendownbulk(items)
        if (response === 'success') {
          setSelectedLinkIds([])
          fetchMatchlinks(type)
        }
      }
    } catch (error) {
      Swal.fire('An Error Occurred', error, 'error')
    }
  }

  const handleScoreChange = (score, setScore, setSelects) => {
    const newScore = parseInt(score, 10) || 0
    setScore(newScore)
    let newSelects = {}
    for (let i = 0; i < newScore; i++) {
      newSelects[i] = ''
    }
    setSelects(newSelects)
  }

  const handleSelectChange = (selects, setSelects, index, value) => {
    setSelects((prev) => ({ ...prev, [index]: value }))
  }

  const handleScoreSubmit = async (e) => {
    e.preventDefault()
    if (!isLoading) {
      try {
        setscoreLoading(true)
        const team1Players = Object.values(team1Selects)
        const team2Players = Object.values(team2Selects)
        let response = await addmatchscore(
          matchId,
          team1score,
          team2score,
          team1Players,
          team2Players,
        )
        if (response === 'success') {
          setscoreLoading(false)
          setshowScoreForm(false)
          fetchMatch()
        }
      } catch (error) {
        console.error('Error submitting scores:', error)
      } finally {
        setscoreLoading(false)
      }
    }
  }

  useEffect(() => {
    const newCounts = {}
    websites.forEach((site) => {
      newCounts[site.id] = site.totalspectators || 0
    })
    setSpectatorCounts(newCounts)
  }, [websites])

  const handleSpectatorChange = (id, value) => {
    setSpectatorCounts((prev) => ({ ...prev, [id]: value }))
    setshowSpecButton(true)
  }

  const handleSubmitSpectators = async () => {
    if (!isLoading) {
      try {
        setspecFormLoading(true)
        let response = await updatematchspectators(matchId, spectatorCounts)
        if (response === 'success') {
          setshowSpecButton(false)
        }
      } catch (error) {
      } finally {
        setspecFormLoading(false)
      }
    }
  }

  const onDrop = async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return

    const imageFiles = acceptedFiles.filter((file) => {
      const validTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
      ]
      return validTypes.includes(file.type)
    })

    if (imageFiles.length === 0) {
      Swal.fire(
        'Invalid File Type',
        'Please upload only image files (JPEG, PNG, GIF, WebP)',
        'error',
      )
      return
    }

    setUploading(true)

    try {
      const formData = new FormData()
      for (let i = 0; i < imageFiles.length; i++) {
        formData.append('screenshots', imageFiles[i])
      }
      formData.append('matchId', matchId)

      const userToken = JSON.parse(localStorage.getItem('userToken'))
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/matches/upload-screenshots`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${userToken.token}`,
            // Don't set Content-Type, browser will set it with boundary for FormData
          },
          body: formData,
        },
      )

      const data = await response.json()

      if (response.ok && data.message === 'success') {
        setUploadedScreenshots((prev) => [...prev, ...data.screenshots])
        Swal.fire('Success', 'Screenshots uploaded successfully', 'success')
      } else {
        Swal.fire(
          'Error',
          data.message || 'Failed to upload screenshots',
          'error',
        )
      }
    } catch (error) {
      Swal.fire(
        'Error',
        'An error occurred while uploading screenshots',
        'error',
      )
      console.error('Upload error:', error)
    } finally {
      setUploading(false)
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp'],
    },
    multiple: true,
  })

  const handleRemoveScreenshot = async (screenshotId, index) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      })

      if (result.isConfirmed) {
        const userToken = JSON.parse(localStorage.getItem('userToken'))

        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/matches/screenshots/delete`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${userToken.token}`,
            },
            body: JSON.stringify({
              screenshotId,
              matchId,
            }),
          },
        )

        const data = await response.json()

        if (response.ok && data.message === 'success') {
          setUploadedScreenshots((prev) => prev.filter((_, i) => i !== index))
          Swal.fire('Deleted!', 'Screenshot has been deleted.', 'success')
        } else {
          Swal.fire(
            'Error',
            data.message || 'Failed to delete screenshot',
            'error',
          )
        }
      }
    } catch (error) {
      Swal.fire('Error', 'Failed to delete screenshot', 'error')
    }
  }

  return (
    <AppLayout pageName='Match Details'>
      {match !== '' ? (
        <>
          <section>
            <div className='py-5'>
              <div className='flex justify-center space-x-4 mb-10'>
                <div className='flex space-x-2 font-normal tracking-wider items-center text-white p-2 rounded-full bg-main pr-3'>
                  {match.competitionId === 1 && (
                    <img
                      className='rounded-full border-4 border-white'
                      width='30'
                      height='30'
                      src={`/images/teams/ligue1.png`}
                    />
                  )}
                  {match.competitionId === 2 && (
                    <img
                      className='rounded-full border-4 border-white'
                      width='30'
                      height='30'
                      src={`/images/teams/ligue2.png`}
                    />
                  )}{' '}
                  <span>{match.compname}</span>
                </div>
                <div className='text-lg tracking-wide p-2 px-5 rounded-full bg-white border text-main-alt border-main-alt'>
                  {match.status}
                </div>
              </div>
              <div className='flex flex-col md:flex-row justify-center space-x-24 heading'>
                <Link
                  to={`/teams/${match.team1name.toLowerCase().replaceAll(' ', '')}/${match.team1}`}
                >
                  <div className='flex flex-col space-y-8 text-3xl font-bold text-main items-center text-center'>
                    <img
                      width='100'
                      height='100'
                      src={getTeamImage(match.team1logo, match.team1name)}
                    />{' '}
                    <div>{match.team1name}</div>
                  </div>
                </Link>
                <div className='flex flex-col space-y-3 text-3xl font-bold text-black text-center justify-center'>
                  {match.matchday !== '' && (
                    <div className='text-base tracking-wide text-neutral-400 font-light'>
                      Matchday: {match.matchday}
                    </div>
                  )}
                  <div className=''>
                    {format(new Date(match.date), 'EEE, do MMM yyyy', {
                      locale: enUS,
                    })}
                  </div>
                  <div className='flex justify-center'>
                    <div className='text-lg tracking-wide p-1 px-5 rounded-full bg-neutral-100 text-neutral-800'>
                      {match.time}
                    </div>
                  </div>
                  {match.team1score != null && match.team2score != null && (
                    <>
                      <div className='flex justify-center items-top space-x-5'>
                        <div>
                          <div
                            className={classNames({
                              'rounded py-2 w-12 text-center text-white':
                                match.team1score != null,
                              'bg-main-alt':
                                match.team1score > match.team2score,
                              'bg-red-700': match.team1score < match.team2score,
                              'bg-neutral-500':
                                match.team1score !== null &&
                                match.team1score === match.team2score,
                            })}
                          >
                            {match.team1score}
                          </div>
                        </div>
                        <div className='text-lg font-bold text-neutral-500 pt-2.5'>
                          -
                        </div>
                        <div>
                          <div
                            className={classNames({
                              'rounded py-2 w-12 text-center text-white':
                                match.team2score != null,
                              'bg-main-alt':
                                match.team2score > match.team1score,
                              'bg-red-600': match.team2score < match.team1score,
                              'bg-neutral-500':
                                match.team1score !== null &&
                                match.team1score === match.team2score,
                            })}
                          >
                            {match.team2score}
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-center items-top'>
                        <div className='flex-1'>
                          {match.team1score > 0 && (
                            <div className='space-y-1 text-neutral-500 text-xs text-right font-normal normal-font'>
                              {team1scorers.map((scorer, index) => {
                                return (
                                  <div
                                    className='whitespace-nowrap'
                                    key={index}
                                  >
                                    {scorer.playername}{' '}
                                    {scorer.origteamid == match.team2 && (
                                      <span className='text-red-500'>
                                        (Own Goal)
                                      </span>
                                    )}
                                  </div>
                                )
                              })}
                            </div>
                          )}
                        </div>
                        <div className='text-lg font-bold text-neutral-500 w-11'></div>
                        <div className='flex-1'>
                          {match.team2score > 0 && (
                            <div className='space-y-1 text-neutral-500 text-xs text-left font-normal normal-font'>
                              {team2scorers.map((scorer, index) => {
                                return (
                                  <div
                                    className='whitespace-nowrap'
                                    key={index}
                                  >
                                    {scorer.playername}{' '}
                                    {scorer.origteamid == match.team1 && (
                                      <span className='text-red-500'>
                                        (Own Goal)
                                      </span>
                                    )}
                                  </div>
                                )
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {showScoreForm ? (
                    <>
                      <form
                        onSubmit={handleScoreSubmit}
                        className='score-form'
                      >
                        <div className='flex justify-center items-top space-x-5'>
                          <div className='flex flex-col items-center'>
                            <input
                              id='team1score'
                              required
                              name='team1score'
                              type='number'
                              min={0}
                              className='form-control !w-12 !p-0 text-center'
                              value={team1score}
                              onChange={(e) => {
                                handleScoreChange(
                                  e.target.value,
                                  setTeam1score,
                                  setTeam1Selects,
                                )
                                setShowTeam1Scorers(false)
                              }}
                            />
                          </div>
                          <div className='text-lg font-bold text-neutral-500 pt-1.5'>
                            -
                          </div>
                          <div className='flex flex-col items-center'>
                            <input
                              id='team2score'
                              required
                              name='team2score'
                              type='number'
                              min={0}
                              className='form-control !w-12 !p-0 text-center'
                              value={team2score}
                              onChange={(e) => {
                                handleScoreChange(
                                  e.target.value,
                                  setTeam2score,
                                  setTeam2Selects,
                                )
                                setShowTeam2Scorers(false)
                              }}
                            />
                          </div>
                        </div>
                        {(team1score > 0 || team2score > 0) && (
                          <div className='mt-6 space-y-4'>
                            <div className='text-center text-sm font-semibold text-neutral-600 mb-3'>
                              Select Scorers
                            </div>
                            <div className='flex justify-center space-x-8'>
                              {team1score > 0 && (
                                <div className='flex flex-col space-y-2 min-w-[200px]'>
                                  {!showTeam1Scorers ? (
                                    <button
                                      type='button'
                                      onClick={() => setShowTeam1Scorers(true)}
                                      className='bg-blue-100 hover:bg-blue-200 transition-colors text-blue-800 text-xs font-medium px-4 py-2 rounded normal-font'
                                    >
                                      Add Scorers
                                    </button>
                                  ) : (
                                    <>
                                      <div className='text-xs font-medium text-neutral-500 mb-1 text-center'>
                                        {match.team1name} Scorers
                                      </div>
                                      {Object.keys(team1Selects).map(
                                        (index) => (
                                          <div key={index}>
                                            <select
                                              value={team1Selects[index]}
                                              onChange={(e) =>
                                                handleSelectChange(
                                                  team1Selects,
                                                  setTeam1Selects,
                                                  index,
                                                  e.target.value,
                                                )
                                              }
                                              className='form-control'
                                              required
                                            >
                                              <option
                                                value=''
                                                disabled
                                                selected
                                              >
                                                Select scorer{' '}
                                                {parseInt(index) + 1}
                                              </option>
                                              {team1players.map((player) => (
                                                <option
                                                  key={player.playerid}
                                                  value={player.playerid}
                                                >
                                                  {player.name}
                                                </option>
                                              ))}
                                              <optgroup label='if own goal'>
                                                {team2players.map((player) => (
                                                  <option
                                                    key={player.playerid}
                                                    value={player.playerid}
                                                  >
                                                    {player.name}
                                                  </option>
                                                ))}
                                              </optgroup>
                                            </select>
                                          </div>
                                        ),
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                              {team2score > 0 && (
                                <div className='flex flex-col space-y-2 min-w-[200px]'>
                                  {!showTeam2Scorers ? (
                                    <button
                                      type='button'
                                      onClick={() => setShowTeam2Scorers(true)}
                                      className='bg-blue-100 hover:bg-blue-200 transition-colors text-blue-800 text-xs font-medium px-4 py-2 rounded normal-font'
                                    >
                                      Add Scorers
                                    </button>
                                  ) : (
                                    <>
                                      <div className='text-xs font-medium text-neutral-500 mb-1 text-center'>
                                        {match.team2name} Scorers
                                      </div>
                                      {Object.keys(team2Selects).map(
                                        (index) => (
                                          <div key={index}>
                                            <select
                                              value={team2Selects[index]}
                                              onChange={(e) =>
                                                handleSelectChange(
                                                  team2Selects,
                                                  setTeam2Selects,
                                                  index,
                                                  e.target.value,
                                                )
                                              }
                                              className='form-control'
                                              required
                                            >
                                              <option
                                                value=''
                                                disabled
                                                selected
                                              >
                                                Select scorer{' '}
                                                {parseInt(index) + 1}
                                              </option>
                                              {team2players.map((player) => (
                                                <option
                                                  key={player.playerid}
                                                  value={player.playerid}
                                                >
                                                  {player.name}
                                                </option>
                                              ))}
                                              <optgroup label='if own goal'>
                                                {team1players.map((player) => (
                                                  <option
                                                    key={player.playerid}
                                                    value={player.playerid}
                                                  >
                                                    {player.name}
                                                  </option>
                                                ))}
                                              </optgroup>
                                            </select>
                                          </div>
                                        ),
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        <div className='flex justify-center space-x-2 mt-6'>
                          <button
                            type='button'
                            onClick={() => {
                              setshowScoreForm(false)
                              setTeam1score('')
                              setTeam2score('')
                              setTeam1Selects({})
                              setTeam2Selects({})
                              setShowTeam1Scorers(false)
                              setShowTeam2Scorers(false)
                            }}
                            className='bg-green-100 hover:bg-green-200 transition-colors text-main-alt text-xs font-medium px-2.5 py-2 rounded normal-font'
                          >
                            Cancel
                          </button>
                          <button
                            type='submit'
                            className='bg-main transition-colors text-white text-xs font-medium px-2.5 py-2 rounded normal-font'
                            disabled={scoreLoading}
                          >
                            {scoreLoading ? 'Saving...' : 'Save'}
                          </button>
                        </div>
                      </form>
                    </>
                  ) : (
                    <>
                      <div className='flex justify-center space-x-2'>
                        <button
                          onClick={() => setshowScoreForm(!showScoreForm)}
                          className='bg-green-100 hover:bg-green-200 transition-colors text-main-alt text-xs font-medium px-2.5 py-2 rounded normal-font'
                        >
                          Update Score
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <Link
                  to={`/teams/${match.team2name.toLowerCase().replaceAll(' ', '')}/${match.team2}`}
                >
                  <div className='flex flex-col space-y-8 text-3xl font-bold text-main items-center text-center'>
                    <img
                      width='100'
                      height='100'
                      src={getTeamImage(match.team2logo, match.team2name)}
                    />{' '}
                    <div>{match.team2name}</div>
                  </div>
                </Link>
              </div>
            </div>
          </section>
          <section className='relative'>
            <button
              type='button'
              onClick={handleDownloadExcel}
              disabled={excelDownloading}
              className='btn-main-inverse absolute top-0 right-0 disabled:opacity-60 m-2'
            >
              <span>Download Excel File</span>
              {excelDownloading ? (
                <Spinner
                  size={14}
                  animating={excelDownloading}
                />
              ) : (
                <FiDownload />
              )}
            </button>
            <div className='flex flex-col lg:flex-col justify-between items-center space-x-3'>
              <div className='text-center'>
                <h2 className='text-2xl font-bold tracking-normal text-main mb-2'>
                  Match Links
                </h2>
                <div className='flex flex-row items-center space-x-3 mb-2'>
                  <div>
                    <span className='bg-blue-100 text-blue-800 text-sm font-medium px-3 py-2 rounded'>
                      Total Links:{' '}
                      {liveCount + highlightCount + googleCount > 0
                        ? (
                            liveCount +
                            highlightCount +
                            googleCount
                          ).toLocaleString()
                        : '0'}
                    </span>
                  </div>
                  <div>
                    <span className='bg-green-100 text-green-800 text-sm font-medium px-3 py-2 rounded'>
                      Number of Spectators:
                      {totalSpectators > 0
                        ? ` ${Intl.NumberFormat('en-US').format(parseInt(totalSpectators)).replace(/,/g, ' ')}`
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
              {websitesLinks && (
                <div className='flex flex-wrap flex-row items-center justify-center mb-4'>
                  {websitesLinks.map((website, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div className='flex space-x-2 border rounded p-1 pr-2 m-2 items-center'>
                          <div>
                            <img
                              width='40'
                              height='40'
                              src={`${process.env.REACT_APP_STATIC_URL || ''}${website.icon}`}
                            />
                          </div>
                          <div>
                            <h6 className='text-neutral-500 text-xs'>
                              {website.name}
                            </h6>
                            <h5 className='text-main-alt leading-none mt-0.5 font-bold'>
                              {website.name == 'Google' ||
                              website.name == 'Bing'
                                ? googleCount
                                : website.total}
                            </h5>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </div>
              )}
            </div>
            <div className='pills w-full rounded-lg p-0 text-black font-semibold flex'>
              <button
                className={`${
                  activeSection === 'links' && type === 'Live'
                    ? 'bg-white border border-b-white'
                    : 'hover:bg-neutral-50 border-b text-neutral-500'
                } rounded-t-lg w-1/3 p-4 flex justify-center space-x-2`}
                onClick={() => {
                  setActiveSection('links')
                  handleSetType('Live')
                }}
              >
                <span>Live</span>
                {liveCount > 0 && (
                  <span className='bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded'>
                    {liveCount}
                  </span>
                )}
              </button>
              <button
                className={`${
                  activeSection === 'links' && type === 'Highlight'
                    ? 'bg-white border border-b-white'
                    : 'hover:bg-neutral-50 border-b text-neutral-500'
                } rounded-t-lg w-1/3 p-4 flex justify-center space-x-2`}
                onClick={() => {
                  setActiveSection('links')
                  handleSetType('Highlight')
                }}
              >
                <span>Highlights</span>
                {highlightCount > 0 && (
                  <span className='bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded'>
                    {highlightCount}
                  </span>
                )}
              </button>
              <button
                className={`${
                  activeSection === 'links' && type === 'Google'
                    ? 'bg-white border border-b-white'
                    : 'hover:bg-neutral-50 border-b text-neutral-500'
                } rounded-t-lg w-1/3 p-4 flex justify-center space-x-2`}
                onClick={() => {
                  setActiveSection('links')
                  handleSetType('Google')
                }}
              >
                <span>Google & Bing</span>
                {googleCount > 0 && (
                  <span className='bg-green-100 text-green-800 text-sm font-medium px-2.5 py-0.5 rounded'>
                    {googleCount}
                  </span>
                )}
              </button>
            </div>
            {activeSection === 'links' && (
              <section className='space-y-6 !rounded-t-none !border-t-0'>
                <button
                  onClick={() => setshowLinkForm(!showLinkForm)}
                  className='btn-main-inverse mb-3'
                >
                  New Links <FiPlus />
                </button>
                {showLinkForm && (
                  <section>
                    {parsedLinks.length === 0 ? (
                      <div>
                        <div className='p-2'>
                          <textarea
                            name='linksinput'
                            rows={8}
                            className='form-control'
                            placeholder='Copy and paste the links here...'
                            value={linksInput}
                            onChange={(e) => setlinksInput(e.target.value)}
                          ></textarea>
                        </div>
                        <div className='p-2'>
                          <div
                            className='flex items-center p-4 border-l-4 border-neutral-400 bg-neutral-100'
                            role='alert'
                          >
                            <svg
                              className='flex-shrink-0 w-4 h-4'
                              aria-hidden='true'
                              xmlns='http://www.w3.org/2000/svg'
                              fill='currentColor'
                              viewBox='0 0 20 20'
                            >
                              <path d='M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z' />
                            </svg>
                            <div className='ms-3 text-sm font-medium text-gray-700'>
                              Please make sure each link is in a separate line.
                            </div>
                          </div>
                        </div>
                        <div className='p-2 flex space-x-5 items-center'>
                          <button
                            type='button'
                            className='btn-submit'
                            onClick={handleParseLinks}
                          >
                            <span>Next</span>
                            <span>
                              <HiArrowNarrowRight />
                            </span>
                          </button>
                          {linksError !== '' && (
                            <div className='text-red-500 font-semibold text-md tracking-wide'>
                              {linksError}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <form
                        onSubmit={handleLinksSubmit}
                        method='post'
                      >
                        <div className='p-2 flex space-x-5 items-center'>
                          <button
                            type='button'
                            className='btn-main-inverse'
                            onClick={() => setParsedLinks([])}
                          >
                            Back
                          </button>
                          <button
                            type='submit'
                            className='btn-submit'
                            disabled={isLoading}
                          >
                            <span>Submit</span>
                            <span>
                              {linkFormLoading === false ? (
                                <HiArrowNarrowRight />
                              ) : (
                                <Spinner
                                  size={14}
                                  className='ml-2'
                                  animating={linkFormLoading}
                                />
                              )}
                            </span>
                          </button>
                          {linksError !== '' && (
                            <div className='text-red-500 font-semibold text-md tracking-wide'>
                              {linksError}
                            </div>
                          )}
                        </div>
                        <div className='p-2 space-y-2'>
                          {parsedLinks.map((item, index) => (
                            <div
                              key={index}
                              className='flex items-center gap-3 p-2 bg-neutral-50 rounded border border-neutral-200'
                            >
                              <div
                                className='flex-1 truncate text-sm text-neutral-700'
                                title={item.link}
                              >
                                {item.link}
                              </div>
                              <div className='flex items-center gap-1.5 shrink-0'>
                                <label className='text-xs text-neutral-500 whitespace-nowrap'>
                                  Spectators
                                </label>
                                <input
                                  type='number'
                                  min='0'
                                  className='form-control w-24 text-sm'
                                  value={item.spectators}
                                  onChange={(e) => {
                                    const updated = [...parsedLinks]
                                    updated[index].spectators =
                                      parseInt(e.target.value, 10) || 0
                                    setParsedLinks(updated)
                                  }}
                                />
                              </div>
                              <button
                                type='button'
                                className='text-red-400 hover:text-red-600'
                                title='Remove link'
                                onClick={() =>
                                  setParsedLinks(
                                    parsedLinks.filter((_, i) => i !== index),
                                  )
                                }
                              >
                                <MdOutlineDelete size={18} />
                              </button>
                            </div>
                          ))}
                        </div>
                      </form>
                    )}
                  </section>
                )}

                <div>
                  {(type === 'Live' || type === 'Highlight') &&
                    selectedLinkIds.length > 0 && (
                      <div className='flex items-center gap-3 mb-3'>
                        <span className='text-sm text-neutral-600'>
                          {selectedLinkIds.length} selected
                        </span>
                        <button
                          type='button'
                          onClick={handleBulkTakendown}
                          className='px-3 py-1.5 rounded bg-main text-white text-sm hover:opacity-90'
                        >
                          Set taken down time
                        </button>
                        <button
                          type='button'
                          onClick={() => setSelectedLinkIds([])}
                          className='px-3 py-1.5 rounded border border-neutral-300 text-sm hover:bg-neutral-50'
                        >
                          Clear selection
                        </button>
                      </div>
                    )}
                  {linksLoading ? (
                    <div className='flex justify-center w-full py-12'>
                      <Spinner
                        color='#CCCCCC'
                        size={24}
                      />
                    </div>
                  ) : (
                    <DataTable
                      data={matchLinks}
                      columns={linkTableColumns}
                      defaultPageSize={50}
                      pageSizeOptions={[10, 25, 50, 100]}
                      onFilteredRowsChange={setFilteredLinks}
                    />
                  )}
                </div>
              </section>
            )}
          </section>
          <section>
            <h2 className='text-2xl font-bold tracking-normal text-main mb-4'>
              Match Screenshots
            </h2>
            <div
              {...getRootProps()}
              className={classNames(
                'border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors',
                {
                  'border-main bg-main/5': isDragActive,
                  'border-neutral-300 hover:border-main hover:bg-neutral-50':
                    !isDragActive,
                },
              )}
            >
              <input {...getInputProps()} />
              <div className='flex flex-col items-center space-y-3'>
                <FiUpload className='text-4xl text-neutral-400' />
                {isDragActive ? (
                  <p className='text-main font-medium'>
                    Drop the screenshots here...
                  </p>
                ) : (
                  <>
                    <div>
                      <p className='text-neutral-600 font-medium mb-1'>
                        Drag & drop screenshots here, or click to select
                      </p>
                      <p className='text-sm text-neutral-500'>
                        Supports: JPEG, PNG, GIF, WebP
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
            {uploading && (
              <div className='flex justify-center items-center mt-4'>
                <Spinner
                  color='#CCCCCC'
                  size={24}
                />
                <span className='ml-2 text-neutral-600'>Uploading...</span>
              </div>
            )}
            {uploadedScreenshots.length > 0 && (
              <div className='mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                {uploadedScreenshots.map((screenshot, index) => {
                  const relativeUrl =
                    typeof screenshot === 'string' ? screenshot : screenshot.url
                  const fullUrl = `${STATIC_BASE_URL.replace(/\/$/, '')}${relativeUrl}`

                  return (
                    <div
                      key={screenshot.id || index}
                      className='relative group border rounded-lg overflow-hidden'
                    >
                      <img
                        src={fullUrl}
                        alt={`Screenshot ${index + 1}`}
                        className='w-full h-48 object-cover'
                      />
                      <button
                        onClick={() =>
                          handleRemoveScreenshot(screenshot.id || index, index)
                        }
                        className='absolute top-2 right-2 bg-red-500 text-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600'
                      >
                        <FiX size={16} />
                      </button>
                    </div>
                  )
                })}
              </div>
            )}
          </section>
          <section>
            <h2 className='text-2xl font-bold tracking-normal text-main'>
              Match Spectators
            </h2>
            <table className='table mt-3'>
              <thead>
                <tr>
                  <th
                    scope='col'
                    className='px-6 py-4 text-left'
                  >
                    Plateformes
                  </th>
                  <th
                    scope='col'
                    className='px-6 py-4'
                  >
                    Spectators
                  </th>
                </tr>
              </thead>
              <tbody>
                {specwebsites.map((website, index) => {
                  return (
                    <tr
                      key={website.id}
                      className='border-t'
                    >
                      <td
                        scope='row'
                        className='px-6 py-4 font-medium whitespace-nowrap text-left'
                      >
                        <div className='flex space-x-2 items-center'>
                          <img
                            width='16'
                            height='16'
                            src={`${process.env.REACT_APP_STATIC_URL || ''}${website.icon}`}
                          />
                          <h6 className='text-neutral-900 text-lg'>
                            {website.name}
                          </h6>
                        </div>
                      </td>
                      <td className='px-6 py-3 text-lg text-center'>
                        <input
                          className='form-control py-1 text-center border'
                          value={spectatorCounts[website.id] || 0}
                          onChange={(e) =>
                            handleSpectatorChange(
                              website.id,
                              parseInt(e.target.value),
                            )
                          }
                        />
                      </td>
                    </tr>
                  )
                })}
                <tr>
                  <td></td>
                  <td className='px-6 py-3 text-lg text-center'>
                    {showSpecButton && (
                      <button
                        onClick={handleSubmitSpectators}
                        className='btn-submit mx-auto'
                      >
                        Save changes
                      </button>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </>
      ) : (
        <div className='flex justify-center w-full py-12'>
          <Spinner
            color='#CCCCCC'
            size={24}
          />
        </div>
      )}
    </AppLayout>
  )
}

export default MatchDetails
